<template>
  <div>
    <transition name="fade" :duration="{ enter: 300, leave: 300 }">
      <v-btn class="mt-12 ma-3" style="z-index: 0" v-show="!isVisible" color="primary" fab large dark absolute top right @click="toggleLayerList(true)">
        <v-icon>mdi-layers</v-icon>
      </v-btn>
    </transition>

    <transition name="slide-fade" :duration="{ enter: 300, leave: 300 }">
      <v-card v-show="isVisible" class="ma-3" width="300px">
        <v-card-title class="text-right">
          Layers
          <v-spacer/>
          <v-btn color="primary" fab x-small dark @click="toggleLayerList(false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text id="layerList">
          <v-list dense>
            <v-alert v-if="layers.length == 0" color="primary" dark icon="mdi-alert-circle">No layers</v-alert>

            <draggable v-model="layers" group="layers" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
              <transition-group type="transition" :name="!isDragging ? 'flip-list' : null">
                <v-card height="112px" class="rounded-lg grey lighten-2 mt-2 list-group-item" flat v-for="item in layers" :key="item.order" >
                  <v-card-title style="max-width: 250px" class="subtitle-2 d-inline-block text-truncate">
                    {{item.name}}
                    <v-icon v-if="item.fixed">mdi-lock</v-icon>
                  </v-card-title>

                  <v-card-text>
                    <v-row>
                      <v-col sm="3">
                        <v-switch class="mt-0" :input-value="map.hasLayer(item.layer)" @change="setLayerVisibility(item.layer, $event)" hide-details></v-switch>
                      </v-col>

                      <v-col sm="6">
                        <v-slider :disabled="item.layer.options.opacity === undefined"  :value="item.layer.options.opacity" @change="setLayerOpacity(item.layer, $event)"  min="0" max="1" step="0.1" hide-details></v-slider>
                      </v-col>

                      <v-col sm="2">
                        <v-btn icon color="red" @click="removeLayer(item.layer)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </transition-group>
            </draggable>
          </v-list>
        </v-card-text>
      </v-card>
    </transition>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'LayerList',

  props: {
    map: Object,
    layerControl: Object
  },

  components: {
    draggable
  },

  data: () => ({
    isVisible: false,
    dragOptions: {
      animation: 200
    },
    isDragging: false
  }),

  computed: {
    layers: {
      get () {
        let layerList = this.layerControl ? this.layerControl._layers.filter(x => x.overlay) : []

        layerList = layerList.map((item, index) => {
          let fixed = item.layer.options.opacity === undefined // Only fix GeoJSON layers that dont have opacity

          let order = index + 1
          if (fixed) { // If fixed, means that it is on top so put it in there
            order = order + 100
          }

          item.layer.order = order
          item.layer.fixed = fixed
          return {
            layer: item.layer,
            name: item.name,
            overlay: item.overlay,
            order: order,
            fixed: fixed
          }
        })

        layerList = layerList.sort((a, b) => {
          return a.order - b.order
        })

        return layerList
      },

      set (value) {
        if (this.layerControl) {
          value.forEach(element => {
            this.layerControl.removeLayer(element.layer)
            this.layerControl.addOverlay(element.layer)
          })

          this.layerControl._layers = value
        }
      }
    }
  },

  methods: {
    toggleLayerList (isVisible) {
      this.isVisible = isVisible
    },

    setLayerVisibility (layer, value) {
      if (this.map.hasLayer(layer)) {
        this.map.removeLayer(layer)
      } else {
        this.map.addLayer(layer)
      }
    },

    setLayerOpacity (layer, value) {
      layer.setOpacity(value)
    },

    removeLayer (layer) {
      this.map.removeLayer(layer)
      this.layerControl.removeLayer(layer)
    },

    onMove ({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    }
  }
}
</script>

<style scoped>
  #layerList {
    height: auto;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }

  .list-group-item {
    cursor: move;
  }

  /* Transitions */
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(350px);
    opacity: 0;
  }

  /* List transitions */
  .flip-list-move {
    transition: transform 0.5s;
  }
</style>
